import { SESSION_COOKIE_NAME, SESSION_START_NEEDED_COOKIE_NAME } from './constants';
import { isBrowser } from './helpers/environment_helper';
import { CookieUtils } from './types/cookies_utils';

let timer: any;

const COOKIE_TIMEOUT_IN_MINUTES = 30;
const SESSION_RELOAD_TIMEOUT_IN_MS = 3_600_000; // 60 min in milliseconds

class Session {
  constructor(private readonly cookieUtils: CookieUtils) {}

  getSessionIdFromCookie() {
    return this.cookieUtils.getCookie(SESSION_COOKIE_NAME);
  }

  // Generate new session ID if no valid session ID exist
  // Re-write session ID with new exp time if valid session ID exist
  updateSessionId() {
    const sessionId = this.getSessionIdFromCookie() || new Date().getTime().toString();
    this.cookieUtils.setCookie(SESSION_COOKIE_NAME, sessionId, 30);
  }

  getSessionId() {
    this.updateSessionId();
    return this.getSessionIdFromCookie();
  }

  sessionStartNeeded() {
    return (
      !this.getSessionIdFromCookie() || typeof this.getSessionStartNeededCookie() !== 'undefined'
    );
  }

  setSessionStartNeeded() {
    if (!this.getSessionIdFromCookie()) {
      this.cookieUtils.setCookie(
        SESSION_START_NEEDED_COOKIE_NAME,
        'true',
        COOKIE_TIMEOUT_IN_MINUTES,
      );
      if (isBrowser) {
        localStorage.setItem(SESSION_START_NEEDED_COOKIE_NAME, 'true');
      }
    }
  }

  clearSessionStartNeeded() {
    this.cookieUtils.deleteCookie(SESSION_START_NEEDED_COOKIE_NAME);
    if (isBrowser) {
      localStorage.removeItem(SESSION_START_NEEDED_COOKIE_NAME);
    }
  }

  // Helper method for stubbing in specs
  getSessionStartNeededCookie() {
    return this.cookieUtils.getCookie(SESSION_START_NEEDED_COOKIE_NAME);
  }

  setSessionTimeout() {
    function timeoutAction() {
      // We are going to add a nonsense query parameter to get around the page cache
      const url = URL.parse(globalThis.location.href);
      const params = url?.searchParams === undefined ? new URLSearchParams() : url.searchParams;
      params.set('cache_reset', String(new Date().getTime()));
      globalThis.location.search = params.toString(); // causes reload due to param change
    }

    function TimeoutEvent() {
      if (typeof timer !== 'undefined') {
        timer = clearTimeout(timer); // reset as soon as interaction happens
      }
      timer = setTimeout(timeoutAction, SESSION_RELOAD_TIMEOUT_IN_MS);
    }

    // capturing all click, touch, mousemove, and keypress events
    if (isBrowser) {
      globalThis.addEventListener('click', TimeoutEvent, false);
      globalThis.addEventListener('keypress', TimeoutEvent, false);
      globalThis.addEventListener('mousemove', TimeoutEvent, false);
      globalThis.addEventListener('touchstart', TimeoutEvent, false);
    }
  }
}

export default Session;
